import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_ASSETS } from '../data/brand';
interface WordmarkProps {
  tone?: 'dark' | 'light';
  variant?: 'header' | 'footer';
  className?: string;
}
export function Wordmark({
  tone = 'dark',
  variant = 'header',
  className = ''
}: WordmarkProps) {
  const primary = tone === 'dark' ? 'text-navy' : 'text-white';
  const secondary = tone === 'dark' ? 'text-copper' : 'text-aluminum';
  const markClass = variant === 'footer' ? 'h-[58px] w-[58px]' : 'h-[38px] w-[38px] lg:h-[42px] lg:w-[42px]';
  return <Link to="/" className={`group inline-flex items-center gap-3 sm:gap-3.5 ${className}`} aria-label="Robertson Precision — home" data-id="element-500" data-mp="3b0mxufnmxkw2">
      <img src={BRAND_ASSETS.mark} alt="" width={512} height={512} loading="eager" decoding="async" className={`shrink-0 object-contain ${markClass}`} data-id="element-501" data-mp="3k09qod2atidi" />
      <span className="flex flex-col leading-none" data-id="element-502" data-mp="z7eooqcj14rq">
        <span className={`whitespace-nowrap font-display text-[15px] sm:text-[17px] font-semibold tracking-[0.18em] ${primary}`} data-id="element-503" data-mp="19lbf7z8mtcjl">
          ROBERTSON PRECISION
        </span>
        <span className="mt-1.5 flex items-center gap-2" data-id="element-504" data-mp="zm2p5hgw0i2i">
          <span aria-hidden="true" className="h-px w-5 bg-copper" data-id="element-505" data-mp="zoovxevyetjo" />
          <span className={`whitespace-nowrap font-mono text-[9px] sm:text-[10px] tracking-label ${secondary}`} data-id="element-506" data-mp="umpre1oh9ql5">
            SHEAR GEOMETRY TOOLING
          </span>
        </span>
      </span>
    </Link>;
}